import { render, staticRenderFns } from "./GrupoPermissao.vue?vue&type=template&id=68654938&scoped=true"
import script from "./GrupoPermissao.vue?vue&type=script&lang=js"
export * from "./GrupoPermissao.vue?vue&type=script&lang=js"
import style0 from "./GrupoPermissao.vue?vue&type=style&index=0&id=68654938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68654938",
  null
  
)

export default component.exports